// Phone screens composed on a stage for article figures, laid out the way the
// homepage galleries lay them out (data/homepage.js): side by side, centred,
// about 78–83% of the stage tall, bezels a quarter of a phone width apart.
//
// A hero is 15:8 like the homepage stage and sits on the piece's backdrop;
// a figure inside the article is 3:2, so the phones read larger, and sits on
// the plain stage colour. Screens are 750 wide and exported without the
// Dynamic Island, which the frame draws.

const LAYOUTS = {
  "15 / 8": { width: 20.5, top: 8.4, gap: 5.4 },
  "3 / 2": { width: 24, top: 11, gap: 6.3 },
};

/**
 * @param {Array<[string, number]>} screens  [src, height] for each phone, left to right
 * @param {{ratio?: "15 / 8" | "3 / 2", alt?: string}} [options]
 */
export function phoneStage(screens, { ratio = "3 / 2", alt } = {}) {
  const { width, top, gap } = LAYOUTS[ratio];
  const span = screens.length * width + (screens.length - 1) * gap;
  const left = (100 - span) / 2;
  return {
    alt,
    ratio,
    layers: screens.map(([src, height], index) => ({
      src,
      size: [750, height],
      island: true,
      wide: { crop: [0, 0, 750, height], at: [left + index * (width + gap), top, width], phone: true },
    })),
  };
}
